import React, { useState } from 'react'
import { UserAndRollColumns, UserAndRollTableData } from './UserandRollData';

import DataTableHeader from '../../../../../Common/DataTableHeader/DataTableHeader';
import DataTable from '../../../../../Common/DataTable/DataTable';
import DataTableFooter from '../../../../../Common/DataTableFooter/DataTableFooter';

const UserAndRollTable = () => {
    const [data, setData] = useState(UserAndRollTableData)
    const handleDelete = (id) => {
        setData(prevData => prevData.filter(item => item.Id !== id));
    }

    // {/* x---------------------------------x UserAndRoll Table Data x---------------------------------x */ }
    const dataT = data.map((data) => {
        return {
            id: data.Id,
            name: data.name,
            action: (
                <>
                    <button type="button" className="btn "
                        data-bs-toggle="modal"
                        data-bs-target="#exampleModal"
                        data-bs-whatever="@fat"><i
                            className="bi bi-pencil-square"></i></button>
                    <button type="button" className="btn deleterow" onClick={() => handleDelete(data.Id)}><i
                        className="bi bi-trash text-danger"></i></button>
                </>
            ),
        };
    });

    return (
        <div>
            {/* x---------------------------------x CommonDataTableHeader x---------------------------------x */}
            <DataTableHeader />

            {/* x---------------------------------x CommonDataTable x---------------------------------x */}
            <DataTable columns={UserAndRollColumns} data={dataT} />

            {/* x---------------------------------x CommonDataTableFooter x---------------------------------x */}
            <DataTableFooter dataT={dataT} />
        </div>
    )
}

export default UserAndRollTable;